import { createStore } from "solid-js/store";
import { useApplication } from "@/context/app";
import { list, checkupSave } from "../../requests/complaint";
import { createSignal } from "solid-js";

export default function useCheckupComplaint(props) {

  const [complaints, setComplaints] = createSignal([]);

  const [complaintForm, setComplaintForm] = createStore({
    complaints: props.complaints || [],
    complaintId: null,
  });

  const { successToast, errorToast } = useApplication();

  const addComplaint = (complaint) => {
    if (!complaint) {
      errorToast("Invalid complaint data");
      return;
    }

    const exist = complaintForm.complaints.find(c => c.complaintId === complaint.complaintId);
    if (exist) {
      errorToast("Complaint already added");
      return;
    }

    setComplaintForm('complaints', [...complaintForm.complaints, complaint]);
  }

  const removeComplaint = (key) => {
    setComplaintForm('complaints', complaintForm.complaints.filter(complaint => complaint.key !== key));
  }

  const onFetchComplaints = async () => {
    try {
      const data = await list();
      setComplaints(data.list || []);
    } catch(error) {
      setComplaints([]);
    }
  }

  const onSaveComplaint = async () => {

    props.setLoading(true);
    try {
      const formData = new FormData();
      formData.append('complaints', JSON.stringify(complaintForm.complaints));

      const data = await checkupSave(formData);

      if (data.success) {
        successToast(data.message || "Complaint saved successfully");
      } else {
        errorToast(data.message || "Failed to save complaint");
      }
    } catch(error) {
      errorToast("Failed to save complaint");
    } finally {
      props.setLoading(false);
    }
  }

  const handleComplaintInput = (name, value) => {
    setComplaintForm([name], value);
  };

  return {
    complaints,
    complaintForm,
    onSaveComplaint,
    handleComplaintInput,
    onFetchComplaints,
    addComplaint,
    removeComplaint,
  };
}
